import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CustomFormFields.scss';

import { Input } from '@salesforce/design-system-react';

export const Numbers = ({ enabled, required, label, fieldName, handleChange, error, defaultValue }) => {
  const [num, setNum] = useState(0);
  const [numFocused, setNumFocused] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      setNum(defaultValue);
    }
  }, [defaultValue]);

  const numberFormat = new Intl.NumberFormat('en-US');

  return (
    <div className='time-numbers input-numeric'>
      { numFocused ? <><Input
        label={label}
        type='number'
        className='time-numbers-input input-numeric-input'
        value={ num }
        name={fieldName}
        onChange={ (e) => {
          setNum(e.target.value);
          handleChange(e, { fieldName, value: e.target.value });
        }}
        disabled={ !enabled }
        required={ required }
        errorText={error}
        onBlur={ () => {
          setNumFocused(false);
        }}
      /></> :
      <><Input
        label={label}
        type='text'
        className='time-numbers-input input-numeric-input'
        disabled={ !enabled }
        required={ required }
        value={ numberFormat.format(num) }
        errorText={error}
        defaultValue={defaultValue}
        onFocus={ () => {
          setNumFocused(true);
        }}
      /> </>
      }
    </div>
  );
};

Numbers.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  defaultValue: PropTypes.number,
};
